module.exports = __webpack_public_path__ + "static/media/iconNext.313b692b.svg";